import React from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarLayout from '../../components/SidebarLayout';
import CreateTableForm from './CreateTableForm';
import './styles.css';

const CreateTablePage = () => {
  const navigate = useNavigate();

  return (
    <SidebarLayout>
      <div className="create-table-container">
        <div className="create-table-header">
          <div>
            <h1>Create New Table</h1>
            <p>Define the structure for your data table</p>
          </div>
          <button
            onClick={() => navigate('/visuals/tables')}
            className="create-table-back-btn"
          >
            Back to Tables
          </button>
        </div>

        <CreateTableForm
          onCancel={() => navigate('/visuals/tables')}
          onSuccess={() => navigate('/erp')}
        />
      </div>
    </SidebarLayout>
  );
};

export default CreateTablePage;
